import { Button } from "@mui/material";
import { useCreatePath, useRecordContext, useResourceContext } from "react-admin";
import CloneIcon from "@mui/icons-material/Queue";
import { useNavigate } from "react-router";
import { useFormIsDirty } from "../hooks/useFormIsDirty";

/**
 * Replacement for the react-admin `CloneButton`.
 */
export function CloneButton2() {
  const navigate = useNavigate();
  const formIsDirty = useFormIsDirty();
  const resource = useResourceContext();
  const record = useRecordContext();
  const createPath = useCreatePath();
  const path = createPath({ resource, type: "create" });

  if (formIsDirty) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      startIcon={<CloneIcon />}
      disabled={!record}
      onClick={() => {
        const { id: _, ...data } = record;
        navigate(`${path}?source=${encodeURIComponent(JSON.stringify(data))}`);
      }}
    >
      Duplizieren
    </Button>
  );
}
